import { NodeData } from '../type';
import { AsyncValidator, SyncValidator, Validation } from '../type/validators';
import { throttleRequest } from './dynamicDataSource';

class DropSyncValidatorMock extends SyncValidator {
  public validate(node: NodeData): Validation {
    return throttleRequest(
      Math.round(Math.random() * 1) === 0 ? null : { error: 'Dropped node invalid. Sync validator' }
    );
  }
}

class DropAsyncValidatorMock extends AsyncValidator {
  public validate(node: NodeData): Promise<Validation> {
    return throttleRequest(
      Math.round(Math.random() * 1) === 0 ? null : { error: 'Dropped node invalid. Async validator' }
    );
  }
}

class RenameAsyncValidatorMock extends AsyncValidator {
  public validate(node: NodeData, additionalData?: string): Promise<Validation> {
    const regex = new RegExp(/[@]/g);
    return throttleRequest(
      additionalData!.match(regex) === null && additionalData!.trim().length !== 0
        ? null
        : {
            name: 'Name already taken',
            validation: 'Contains invalid characters',
          }
    );
  }
}

class DeleteAsyncValidator extends AsyncValidator {
  public validate(node: NodeData): Promise<Validation> {
    return throttleRequest(node.parentNodeId !== undefined ? null : { error: true });
  }
}

export const dropSyncValidatorMock = new DropSyncValidatorMock();
export const dropAsyncValidatorMock = new DropAsyncValidatorMock();
export const renameAsyncValidatorMock = new RenameAsyncValidatorMock();
export const deleteAsyncValidator = new DeleteAsyncValidator();
